import { requireOwner } from "$/lib/require-owner"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings")({
  beforeLoad: async ({ context: { queryClient } }) => {
    await requireOwner(queryClient)
  },
  loader: () => ({
    crumb: "alfred.settings.layout.title",
  }),
})
